import React from 'react'
import { Dropdown, Form } from 'react-bootstrap'
import './ReportTypeStyle.css'
import PrintPreview from '../PrintPreview/PrintPreview.component'
import type {
  ReportConfig,
  ClinicInfo,
  PatientInfo,
  ReportImage,
} from '../reportTypes'

interface ReportTypeProps {
  reportConfig: ReportConfig
  onReportTypeChange: (type: 'Full' | 'Summary') => void
  onCategoryToggle: (category: string) => void
  clinicInfo: ClinicInfo
  patientInfo: PatientInfo
  selectedImages: ReportImage[]
}

function ReportType({
  reportConfig,
  onReportTypeChange,
  onCategoryToggle,
  clinicInfo,
  patientInfo,
  selectedImages,
}: ReportTypeProps): React.ReactElement {
  const categories = Object.keys(reportConfig.categories)

  return (
    <div className="rt-layout">
      <div className="rt-preview-side">
        <PrintPreview
          clinicInfo={clinicInfo}
          patientInfo={patientInfo}
          selectedImages={selectedImages}
          reportConfig={reportConfig}
        />
      </div>
      <div className="rt-config-side">
        <h5 className="rt-config-title">Report type</h5>
        <Dropdown className="rt-type-dropdown">
          <Dropdown.Toggle variant="outline-primary" className="rt-type-toggle">
            {reportConfig.reportType}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              active={reportConfig.reportType === 'Full'}
              onClick={() => onReportTypeChange('Full')}
            >
              Full
            </Dropdown.Item>
            <Dropdown.Item
              active={reportConfig.reportType === 'Summary'}
              onClick={() => onReportTypeChange('Summary')}
            >
              Summary
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <div className="rt-categories">
          {categories.map((cat) => (
            <Form.Check
              key={cat}
              type="checkbox"
              label={cat}
              checked={reportConfig.categories[cat]}
              onChange={() => onCategoryToggle(cat)}
              className="rt-category-check"
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default ReportType
